/*
 *@description: 文字路演相关模块
 *@author: qiuhongyang
 *@date: 2021-02-25 09:51:33
 *
*/

import _ from "lodash";
import { getLuyanStatus, dateFormat, debounce } from "../../../modules/utils";
// import { formatHotDegree } from './ly_utils';
import { getCfhApi, isSubscribe, getGubaApi, getLkApi } from "../../../modules/apidata";
import getCampanyInfos from "../../../modules/compannyinfos";
import identify from '../../../modules/identify';
import subscribe from '../../../modules/subscribe';
import shareWechat from '../../../modules/share';
import EM_IM from '../../../../src/modules/em_im';
import smallmodal from '../../../../src/modules/modal/smallmodal';  // 小弹窗
import tiptoast from '../../../modules/modal/tiptoast';
// import changeVedios from '../../../../src/modules/video_wz';
import commontipmodal from '../../../../src/modules/modal/tipmodal';
import passportlogin from "../../../../src/modules/login/passport";
import cookie from '../../../../src/modules/cookie/index';


declare let emsharecfh;
declare let emav: any;


let cfhAccountInfos = {
  Account_Id: '',
  NickName: '',
  RelatedUid: ''
}

/**
   * 加载基本路演信息
   * @param data 
   * @param isSpecialStatus 是否是特殊用户
   */
export function loadBaseInfo(data: any, isSpecialStatus: boolean) {
  let tags = data?.tags || []; //平台
  let show_baseinfo_switch = data?.config?.show_baseinfo_switch;
  // 获取平台数据
  let tagsArr = tags.map(item => {
    let value = item?.value;
    return value.map(v => {
      return `<p>${item.key}：${v}</p>`
    }).join("")
  });

  let intro = data?.intro?.replace(/\r\n|\n|\n\r/g, '<br>');

  let pnstr = "", timestr = "", introstr = "";
  //观看人数
  // if (data.status === 1 && _.has(data, 'linkmic_status.total_user')) {
  //   let onlinenum = data?.linkmic_status?.total_user;
  //   pnstr = `直播观看人数：<span id="personNum">${onlinenum} 人</span>`
  // };

  //热度data.status === 1 && 
  // if (_.has(data, 'heat_degree') && data?.config?.heat_degree_switch) {
  //   let heatdegree = formatHotDegree(data?.heat_degree);
  //   pnstr = `热度：<span id="personNum">${heatdegree}</span>`
  // };

  // 直播介绍
  if (!!intro) {
    introstr = `<div class="article-summary">
            <h3 class="tit"><i class="icon icon_inter"></i><span class="lab">介绍</span></h3>
            <p>简介：${intro}</p>
            ${tagsArr.join("")}
        </div>`
  };

  if (!!show_baseinfo_switch && data?.start_time && data?.end_time) {
    let start_ymd = dateFormat(data?.start_time, 'yyyy.MM.dd'),
      end_ymd = dateFormat(data?.end_time, 'yyyy.MM.dd');
    if (start_ymd == end_ymd) {
      timestr = `时间：<span>${dateFormat(data?.start_time, 'yyyy.MM.dd HH:mm')} - ${dateFormat(data?.end_time, 'HH:mm')}</span>`
    } else {
      timestr = `时间：<span>${dateFormat(data?.start_time, 'yyyy.MM.dd HH:mm')} - ${dateFormat(data?.end_time, 'yyyy.MM.dd HH:mm')}</span>`
    };
  };

  let html = ` 
        <h1 class="article-title">${data?.name || ""}</h1>
        <div id="article-sub-box"></div>
        <div class="article-meta">
            ${timestr}
            ${data?.status == 1 || data?.status == 3 ? ` &nbsp;&nbsp;&nbsp;&nbsp;${pnstr}` : ''}
            <div class="share pull-right emshare2020" id="shareTop" style="display:none"></div>
        </div>
        ${introstr}
        ${getLuyanStatus(data?.status, false)}
        `

  $('.article-head').html(html);
  emsharecfh.set({
    title: data?.name,
    desc: data?.intro,
    summary: ''
  })
};

/**
 * 头部baseinfo刷新 不要loadBaseInfo刷新整个模块
 * @param data 
 */
export function freshBaseData(data) {
  $("#lystatustag").replaceWith($(getLuyanStatus(data?.status, false)));  //刷新状态
};


/**
 * 左侧分享浮层
 */
export let sharebox = {
  setPosition: function () {
    let winWidth: any = $(document).width();
    let winHeight: any = $(document).height();

    let left: any = (winWidth - 1000) / 2 - 95;
    $('#fw').css('left', left + 'px').show();
  },
  init: function () {
    let _self = this;
    this.setPosition();
    $(window).resize(function () {
      _self.setPosition();
    })
    _self.scroll();
    _self.checkscroll();
  },
  sendLookEnd: false,
  checkscroll: function () {
    let scrollTop: any = $(window).scrollTop();
    if (scrollTop > 300) {
      $('#fw').addClass('active');
    } else {
      $('#fw').removeClass('active');
    }

  },
  scroll: function () {
    let _self = this;
    $(window).scroll(function () {
      _self.checkscroll();
    })
  }
};

/**
 * 获取卡片信息（文字直播）
 * @param id 
 * @param isSpecialStatus 是否是特殊用户
 */
export async function getKaPianInfo(id: string, isSpecialStatus: boolean, isAdmin: boolean): Promise<void> {
  $(".campany_intro").hide();
  $(".relative_data").hide();
  try {
    let json: any = await getCfhApi(`Author/GetAuthorDetail`, {
      authorId: id
    });

    if (json && json.Result) {
      let data: any = json?.Result;
      // debugger;
      let { icons, infos } = identify(data);

      console.log(icons)

      // this.getCampanyInfos(data.MarketCode, data.StockCode);  //公司简介

      cfhAccountInfos = {
        Account_Id: data?.Account_Id,
        NickName: data?.NickName,
        RelatedUid: data?.RelatedUid
      };

      let html = ``;

      /** 普通用户视角 */
      if (!isSpecialStatus || !isAdmin) {
        html = `
        <div class="avater">
            <a href="https://i.eastmoney.com/${data?.RelatedUid}" target="_blank">
                <img src="${data.Portrait}" alt="">
            </a>
            ${icons && icons.length ? icons[0] : ""}
        </div> 
        <div class="info item" data-uid="${data.RelatedUid}">
            <p class="name">
                <a href="https://i.eastmoney.com/${data?.RelatedUid}" target="_blank">
                    ${data.NickName || ""}
                </a>
            </p>
            <div class="renzhen">${infos.join("<br />")}</div>
            <button class="btn btn_dy">订阅</button>
        </div>
        <div class="intro">${data.Summary || ""}</div>
      `
      }
      else {
        $(".user-info").remove();  // 特殊不展示右边卡片
        let rzstr = infos && infos?.length ? `(${infos.join('、')})` : '';
        $("#article-sub-box").empty().append($(`<div class="item" data-uid="${cfhAccountInfos?.RelatedUid}"> <a href="http://caifuhao.eastmoney.com/cfh/${cfhAccountInfos.Account_Id}" target="_blank">${cfhAccountInfos?.NickName}${rzstr}</a> <button class="btn btn_dy">订阅</button></div>`))
      };

      $('.user-info').html(html);
      $('.user-info').show();
      /**
       * 头部banner添加订阅关系及事件
       */
      isSubscribe(id, 1).then((data) => {
        if (data && data[id]) {
          $(".btn_dy").addClass('disabled').html("已订阅")
        }
        if (isSpecialStatus) {
          subscribe("#article-sub-box", 1)
        } else {
          subscribe(".user-info", 1)
        }

      }).catch(() => {
        $(".btn_dy").hide();
      });

      if (data.MarketCode != null && data.StockCode != null) {
        await getCampanyInfos(data.MarketCode, data.StockCode);  //公司简介
        // $(".campany_intro").show(); // 隐藏公司简介
        $(".relative_data").show();
      } else {
        $(".campany_intro").hide();
        $(".relative_data").hide();
      }

    }
  } catch (error) {
    console.log(error)
  }

};

/**
 * 股吧发言框 #guba_post_editor
 *
 * @export
 */
export function gbposterbox() {
  let timer: any = null;
  let boxdiv: any = $("#guba_post_editor_bottom");
  let wh: any = $(window).height();
  let gbbox = $("#guba_post_editor");
  $(window).scroll(_.debounce(function () {
    let offtop = boxdiv.offset().top;
    let scrolltop: any = $(document).scrollTop();
    let diff = offtop - scrolltop - wh;

    if (diff > 150) {
      timer = setTimeout(() => {
        gbbox.addClass("guba_hd_position")
      }, 10)
    } else if (diff > 0 && diff < 150) {

    } else {
      timer = setTimeout(() => {
        gbbox.removeClass("guba_hd_position")
      }, 10)
    };

  }, 15));
};


/**
 * 右侧小视频定位控制
 * */
export function smallvedioCtrl() {
  let _small: any = $("#lysmallvedio");
  let _ofsettop = _small.offset().top;
  $(window).scroll(_.debounce(function () {
    let scrolltop: any = $(document).scrollTop();
    if (scrolltop - 100 > _ofsettop) {
      _small.addClass("fixwin")
    } else {
      _small.removeClass("fixwin")
    };

  }, 50));
}



/**
 * 小程序二维码分享
 * @export
 * @param {string} imgsrc
 */
export function wechatQRcode(data: any) {
  let img = data?.share_config?.em_share_qrcode_wl;
  $("#shareTop").show();
  if (!img) return false
  $(".emshare2020_icon_weixin").unbind("click");
  $(".emshare2020_icon_weixin").on("click", function () {
    shareWechat({
      imgsrc: img
    })
  });
};

/**
 * 宣传视频
 *
 * @export
 * @param {string} src
 * @param {string} _env
 */
export function loadPropagateVideo(src: string, _env: string) {
  $("#campany_sum").css({ 'width': '600px' });
  $("#campany_media").css({ 'display': 'block' });
  let html = `<video id="av-player-ctx" class="emav" preload="auto"></video>`;
  $('#campany_media').html(html)

  let videoitem = emav("av-player-ctx", {
    width: 320,//播放器区域宽度，单位像素，按需设置，可通过 CSS 控制播放器尺寸。
    height: 180,//播放器区域高度，单位像素，按需设置，可通过 CSS 控制播放器尺寸。
    controls: true,//是否显示播放器的控制栏，默认true
    poster: 'http://g1.dfcfw.com/g4/202006/20200618162650.png',//设置封面图片完整地址
    posterImage: true,//是否显示封面
    autoplay: false,//是否自动播放，默认false
    loop: false,//是否循环播放，默认false
    muted: false,//是否静音播放，默认false
    preload: 'auto',//是否需要预加载，有 3 个属性"auto"，"meta"，"none" ，移动端由于系统限制，设置 auto 无效。默认auto
    controlBar: {//设置控制栏属性的参数组合
      children: [
        "playToggle",
        "volumePanel"
      ],
      playToggle: true,//是否显示播放、暂停切换按钮
      volumePanel: true,//是否显示音量控制

      remainingTimeDisplay: false,//是否显示视频剩余时间
      currentTimeDisplay: true,//是否显示视频当前时间
      timeDivider: true,//是否显示时间分割符（/）
      durationDisplay: true,//是否显示视频时长

      progressControl: true,//是否显示播放进度条
      playbackRateMenuButton: true,
      fullscreenToggle: true//是否显示全屏按钮
    },
    showContextMenu: false,//是否显示右键菜单，默认false
    showBigPlayButtonOnPaused: true,//暂停时是否显示播放按钮，默认false
    bigPlayButton: true,//是否显示居中的播放按钮
    isAudio: false,//是否为音频，默认false
    statistic: {
      activeTime: true
    },
    env: _env//环境切换，默认为正式环境(production)，测试环境（env）需手动指定
  });
  videoitem.src(src)
};



/**
 * 文字路演im事件 
 * @param detailinfo 
 * @param emavid 
 * @returns 
 */
export function wzluyanIM(detailinfo: any) {

  /**
 * im 事件
 */

  let that = this;
  let cover = detailinfo?.cover || "";

  // im 链接测试
  EM_IM.onShowStart(function (data: any = {}) {
    // console.log("_im_start")
    data.cover = cover;
    // $("#lystatustag").removeClass("yugao").addClass("zhibo").text("LIVE");
    $("#lystatustag").hide();

    let livechapter = data?.live_chapter;
    let haveZBlist = livechapter && livechapter.length > 0 && livechapter?.[0]?.media_group[0]?.media?.url;
    //有直播
    if (!!haveZBlist) {
      smallmodal.init({
        tipinfos: "路演已开始，请点击观看",
        subtext: "确认",
        iconname: "icon_wzzb",
        showsubbtn: true,
        showcancelbtn: false,
        boxid: "#vedioCtrlBox",
        subcallback: function () {
          that.zbLuyanVideo(data)
        }
      });
    } else {
      that.zbLuyanVideo(data)
    };
  });

  EM_IM.onShowEnd(function (data: any = {}) {
    // console.log("_im_end")
    data.cover = cover;
    $("#lystatustag").show();
    $("#lystatustag").removeClass("zhibo").addClass("huigu").text("回顾");
    $('#guba_post_editor').hide();

    let playback = data?.playback_chapter;
    let havehglist = playback && playback.length > 0 && playback?.[0]?.media_group[0]?.media?.url;
    if (!!havehglist) {
      smallmodal.init({
        tipinfos: "已结束",
        subtext: "确认",
        iconname: "icon_wzzb",
        showsubbtn: true,
        showcancelbtn: false,
        boxid: "#vedioCtrlBox",
        subcallback: function () {
          if (playback) {
            that.zbLuyanVideo(data)
            // that.freZBVideo(false)
          } else {
            $("#vedioCtrlBox").hide();
          }
        }
      });
    } else {
      that.zbLuyanVideo(data)
      // that.freZBVideo(false)
    }

  })

  EM_IM.onDeleteRome(function () {
    // console.log("_im_onDelete");
    self.location.href = "/404.html";
  })

  //预告播放地址变更
  EM_IM.onChangeForeshow(function (data: any) {
    // console.log("_im_预告播放地址变更")
    data.cover = cover;
    that.zbLuyanVideo(data, true)

  })

  // 直播地址变更
  EM_IM.onChangeLiveshow(function (data) {
    // console.log("_im_直播地址变更")
    data.cover = cover;
    that.zbLuyanVideo(data, true)
  })

};

/**
 * 互动类型标签
 *
 * @export
 */
export function loadChatTabs() {
  let html: string = ``;
  if (!this.isSpecialStatus) {
    $("#refreshActions").find(".order").hide();
    html = ' <li class="active" data-id="0">全部</li><li data-id="1" class="myquestiontab">我的提问</li>'
  } else {
    html = `<li class="active" data-id="0">全部</li>
              <li data-id="2">提到我的</li>
              <li data-id="6">已精选</li>
              <li data-id="3">未回答</li>
              <li data-id="4">已回答</li>
              <li data-id="5">回收站</li>
              `
  }
  $('.luyan_tabs').html(html)
}
/**
 * 活动议程
 *
 * @export
 * @returns
 */
export function loadAgenda() {
  let data: any = this.agendas;
  if (!data || !data.length) {
    return;
  }

  let html = data.map(item => {
    return `<li>
                  <div>${dateFormat(item.start, 'yyyy年MM月dd日 HH:mm')}-${dateFormat(item.end, 'HH:mm')}</div>
                  <div>${item.name}</div>
              </li>`
  })

  $('#program_outline ul').html(html.join(""));
  $('#program_outline').show();
}

/**
 * 嘉宾列表
 *
 * @export
 */
export function loadGuests() {
  let that = this;
  let data: any = this.guests;
  if (!data || !data.length) {
    return;
  };
  this.guestList = []; // 会被this全局调用

  // 将自己放在首位
  data.map((v, i) => {
    if (v.emuid == that.uid) {
      data.unshift(data.splice(i, 1)[0])
    }
  });

  let html = data.map((item, i) => {
    this.guestList.push({
      guestUid: item.emuid,
      guestName: item.target_nickname || item.nickname,
      guestIdentity: item.position
    });

    let intro = item.intro ? item.intro : "";
    let selflab = this.uid == item.emuid ? `<span class="lab">我</span>` : "";

    return `<li>
                <div class="avater"><img src="${item.avatar}" alt=""></div>
                <div class="defail">
                    <h3 class="name">${item.target_nickname || item.nickname} ${selflab}</h3>
                    <p class="intro">${item.position || ""}</p>
                    ${intro.trim() ? `<p class="summary">${intro}</p>` : ""}
                </div>
            </li>`
  });

  $('#jiabing_wrap ul').html(html.join(""));
  $('#jiabing_wrap').show();

  //嘉宾为1时默认展开
  if (data.length == 1) {
    $(".jiabing").find(".summary").show()
  };
}

/**
 * showloding
 *
 * @export
 */
export function showLoading() {
  $('.luyan_content>ul').addClass('loading')
}

/**
 * hideloading
 *
 * @export
 */
export function hideLoading() {
  $('.luyan_content>ul').removeClass('loading')
}

/**
 * 进入房间统计
 *
 * @export
 * @returns
 */
export async function calculateEnter(authinfo, accountInfo) {
  let access_token = authinfo?.data?.access_token || ""
  let json: any = await getLkApi('api/RoomAction/Enter', {
    channel_id: accountInfo.id,
    access_token: access_token
  })
  //删除5002
  if (json?.result == 5002) {
    self.location.href = "/404.html";
    return false
  }
};


/**
 *  预告提问提示
 */
export function tiwenTip() {
  let that = this;
  commontipmodal.init({
    tipinfos: `<p class="tips">友情提醒：为广泛听取投资者的意见和建议，提问通道现已开放，向投资者公开征集问题。</p>`,
    subtext: "去提问",
    iconname: "icon_wzzb",
    showsubbtn: true,
    showcancelbtn: true,
    boxid: "body",
    subcallback: function () {

      let uid = ((cookie.get('uidal')) || ""); //用户uid
      if (!uid) {

        passportlogin.request();

        return false;
      };
      $(".extendbtn").trigger("click");
      $(".editor_txt").trigger("focus");
    }
  });
};


/**
 * 授权判断
 *
 * @export
 */
export function generateAuthentic(authinfo) {
  let viewtype = authinfo?.data?.view_type;

  if (viewtype == 4) {
    let code = authinfo?.data?.code;
    let whitelisttype = authinfo?.data?.whitelist_config?.whitelist_type;
    // 黑名单房间
    if (code == 40101 && whitelisttype == 5) {
      self.location.href = "/404.html";
      return false
    }
  }
};

/**
 * 直播封面
 * @param data 
 * @returns 
 */
export function getCover(data: any) {
  if (data?.h_cover) {
    return data.h_cover
  }

  if (data?.cover) {
    return data.cover
  }

  return data?.v_cover || ""
}


/**
 * 预告阻止评论
*/
export function forbidChat(status, can_comment) {
  $("#chatmask").remove();
  if (status == 4 && !can_comment) {
    let mask = `<div id="chatmask" style="opacity:1;position:absolute;top:0;right:0;left:0;bottom:0;z-index:999"></div>`
    $("#guba_post_editor").append($(mask));

    $("#guba_post_editor").on("click", "#chatmask", function (e) {
      e.preventDefault();
      tiptoast.show({
        content: "本场直播提问暂未开放",
        callback: function () { }
      });
      return false
    })
  }
}

/**
 * 禁止嘉宾或主持人 除非admin=1 评论
 */
export function forbidAdminChat(isSpecialStatus: boolean, isAdmin: boolean, isPresenter: boolean) {
  if (isSpecialStatus && !isAdmin) {
    $("#chatmask2").remove();
    let mask = `<div id="chatmask2" style="opacity:1;position:absolute;top:0;right:0;left:0;bottom:0;z-index:999"></div>`
    $("#guba_post_editor").append($(mask));

    let identity = isPresenter ? "主持人" : "嘉宾";

    $("#guba_post_editor").on("click", "#chatmask2", function (e) {
      e.preventDefault();

      commontipmodal.init({
        tipinfos: `<p class="modal_cont_txt">您当前为该场直播的${identity}，请前往企业通进行操作，若有任何疑问，请联系对应服务经理。</p>`,
        subtext: "确定",
        iconname: "",
        showtitle: true,
        showsubbtn: true,
        showcancelbtn: false,
        showwarmicon: true,
        boxid: "body",
        subcallback: function () { }
      });

      return false
    })
  }
}

/**
 * 视频流数据地址获取
 * @param list 
 * @param emavid 
 * @returns 
 */
export function formatVideoList(list: Array<any>, emavid: string) {
  let newarr = list.filter(function (v) {
    v.emavid = emavid;
    return v.media_group.length > 0 && !!v.media_group?.[0]?.media?.url
  });

  // console.log(newarr)
  return newarr;
}